module.exports = __webpack_public_path__ + "static/media/Chat.00cf6819.svg";